import React from 'react';
import { useTypedTranslation } from '@app/hooks';
import { TranslationsTypes } from '@app/models';

interface IProps {
    header: TranslationsTypes;
    text: TranslationsTypes;
}

export const NoContent: React.SFC<IProps> = (props) => {
    const { translation } = useTypedTranslation();
    const { header, text } = props;

    return (
        <div className='no-content'>
            <div className='no-content__content'>
                <h3>{translation(header)}</h3>
                <p>{translation(text)}</p>
            </div>
        </div>
    );
};
